var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWalletLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4727_65954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02478 11.4653V11.4653C7.0319 10.3147 6.34908 7.76639 7.49967 5.7735L8.74968 3.60844C9.90027 1.61555 12.4486 0.93274 14.4414 2.08333V2.08333C16.4343 3.23393 17.1171 5.78222 15.9666 7.7751L15.3416 8.85764L14.6645 10.0304",
    stroke: "#73756D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.691 8.57867V8.57867C12.6839 9.72926 13.3667 12.2776 12.2161 14.2704L10.9661 16.4355C9.81555 18.4284 7.26726 19.1112 5.27437 17.9606V17.9606C3.28149 16.81 2.59868 14.2617 3.74927 12.2688L4.37427 11.1863L5.05135 10.0136",
    stroke: "#73756D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4727_65954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWalletLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wallet_link.fc06750ad2dbeb3d6e704b0f65beb710.svg";